import { BsFillXSquareFill } from 'react-icons/bs'
import useImportFile from '../../../../../hooks/useImportFile'
import CSVUpload from './CsvUpload/CSVUpload'

const ImportFile = () => {
  const { uploadData, setUploadData, upload, baseUrl, navigatePrevPage } =
    useImportFile()

  return (
    <div className="box inner-box stack">
      <span className="cursor-pointer upper-right">
        <BsFillXSquareFill size={'1rem'} onClick={navigatePrevPage} />
      </span>
      <span>以下の製品・サービスの連絡先（電話帳）CSVファイルからのインポートに対応しています。</span>
      <span style={{ marginLeft: '2rem' }} >本サービス標準/+電話帳Cloud/CloudPhone Biz Pro/Yealink社製SIP電話機</span>
      <span>文字コードは自動判別されます。</span>
      <span>新規の連絡先はランダムなIDで登録されます。</span>

      <CSVUpload setUpload={setUploadData} />

      <hr />

      <div className="switcher">
        <button
          type="button"
          className="submitButton"
          onClick={(e) => {
            upload(e, baseUrl)
          }}
          disabled={uploadData.length <= 0}
        >
          アップロード
        </button>

        <button
          type="button"
          className="submitButton btn-danger ms-3"
          onClick={navigatePrevPage}
        >
          キャンセル
        </button>
      </div>
    </div>
  )
}

export default ImportFile
